import { render, staticRenderFns } from "./ProformaFeatures.vue?vue&type=template&id=516f14bf&"
import script from "./ProformaFeatures.vue?vue&type=script&lang=js&"
export * from "./ProformaFeatures.vue?vue&type=script&lang=js&"
import style0 from "./ProformaFeatures.vue?vue&type=style&index=0&id=516f14bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports